"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/MessageTemplates/TemplatesDialog/UsePane.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);





var _templateResolver = require('shared/services/templateResolver');
var _time = require('shared/services/time');

var _TemplateEditorModal = require('../TemplateEditorModal');
var _controls = require('./controls');






















const USE_EDIT = [{ value: 'use' , label: 'Use' }, { value: 'edit' , label: 'Edit' }]

/* The message as it would go out: the chat's values in, each value still to
 * fill as its name (or what was typed for it), highlighted. */
const Bubble = ({ body, fill, typed }) => {
  const resolved = _templateResolver.resolveTemplate.call(void 0, body, fill.values, fill.defaults)
  const pieces = []
  let last = 0
  resolved.unresolved.forEach((blank, i) => {
    pieces.push(resolved.text.slice(last, blank.start))
    pieces.push(_react2.default.createElement('mark', { key: i, className: "tdlg-mark", __self: this, __source: {fileName: _jsxFileName, lineNumber: 44}},  _optionalChain([typed, 'access', _ => _[blank.name], 'optionalAccess', _2 => _2.trim, 'call', _3 => _3()]) || blank.name ))
    last = blank.end
  })
  pieces.push(resolved.text.slice(last))
  return _react2.default.createElement('p', { className: "tdlg-bubble", 'data-testid': "template-preview", __self: this, __source: {fileName: _jsxFileName, lineNumber: 48}},  pieces )
}

/* The chosen template, ready to use: the message as the patient would get it,
 * a field for each value left, and Insert in the footer. */
const UsePane = ({
  row, context, fill, typed, onType, needsPatient, patientKey, onPatient, insertable, busy, gone, onInsert, onToggle, onDuplicate,
}) => {
  const template = row.template
  // The fields: what the chat can't fill. Typing doesn't remove a field.
  const blanks = _react.useMemo.call(void 0, 
    () => insertable ? _templateResolver.resolveTemplate.call(void 0, template.Body, fill.values, fill.defaults).missing : [],
    [insertable, template.Body, fill],
  )
  const shownFill = insertable ? fill : { values: {}, defaults: {} }
  const left = blanks.filter(name => !_optionalChain([typed, 'access', _4 => _4[name], 'optionalAccess', _5 => _5.trim, 'call', _6 => _6()])).length
  const onFieldKey = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      onInsert()
    }
  }

  return (
    _react2.default.createElement('section', { className: "templates-dialog--use", 'aria-label': template.Name, __self: this, __source: {fileName: _jsxFileName, lineNumber: 72}}
      , _react2.default.createElement('div', { className: "templates-dialog--pane-body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 73}}
        , _react2.default.createElement('div', { className: "templates-dialog--pane-head", __self: this, __source: {fileName: _jsxFileName, lineNumber: 74}}
          , _react2.default.createElement('h4', { className: "templates-dialog--use-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 75}},  template.Name )
          , _react2.default.createElement('span', { className: "tdlg-pill", __self: this, __source: {fileName: _jsxFileName, lineNumber: 76}},  row.scopeLabel )
          ,  template.CanEdit
            ? _react2.default.createElement(_controls.Segmented, { label: "Template view" , value: "use", options: USE_EDIT, onChange: onToggle, __self: this, __source: {fileName: _jsxFileName, lineNumber: 78}} )
            : _react2.default.createElement('button', { type: "button", className: "tdlg-link templates-dialog--head-link" , onClick: () => onDuplicate(template), __self: this, __source: {fileName: _jsxFileName, lineNumber: 79}}, "Duplicate to edit"  )
          
        )
        , _react2.default.createElement('p', { className: "tdlg-meta", __self: this, __source: {fileName: _jsxFileName, lineNumber: 82}}, "Last edited by "
             , _react2.default.createElement(_TemplateEditorModal.UserName, { userKey: template.UpdatedBy, isAdmin: template.UpdatedByAdmin, __self: this, __source: {fileName: _jsxFileName, lineNumber: 83}} ), " · "  ,  _time.formatLongDisplayDate.call(void 0, template.UpdatedAt) 
        )
        , _react2.default.createElement(Bubble, { body: template.Body, fill: shownFill, typed: typed, __self: this, __source: {fileName: _jsxFileName, lineNumber: 85}} )
        ,  insertable && needsPatient && (
          _react2.default.createElement('fieldset', { className: "templates-dialog--patients", __self: this, __source: {fileName: _jsxFileName, lineNumber: 87}}
            , _react2.default.createElement('legend', { className: "tdlg-label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 88}}, "Insert for" )
            ,  context.patients.map(p => (
              _react2.default.createElement('label', { key: p.PatientKey, className: "tdlg-radio", __self: this, __source: {fileName: _jsxFileName, lineNumber: 90}}
                , _react2.default.createElement('input', {
                  type: "radio",
                  name: "templates-dialog-patient",
                  value: p.PatientKey,
                  checked: patientKey === p.PatientKey,
                  onChange: () => onPatient(p.PatientKey), __self: this, __source: {fileName: _jsxFileName, lineNumber: 91}}
                )
                ,  `${p.FirstName} ${p.LastName}`.trim() || 'Unnamed patient' 
              )
            ))
          )
        )
        ,  blanks.length > 0 && (
          _react2.default.createElement('div', { className: "templates-dialog--fill", __self: this, __source: {fileName: _jsxFileName, lineNumber: 104}}
            , _react2.default.createElement('p', { className: "tdlg-label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 105}}, "Fill in before inserting"   )
            ,  blanks.map(name => (
              _react2.default.createElement('label', { key: name, className: "templates-dialog--fill-row", __self: this, __source: {fileName: _jsxFileName, lineNumber: 107}}
                , _react2.default.createElement('code', { className: "templates-dialog--fill-name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 108}},  name )
                , _react2.default.createElement('input', {
                  className: "tdlg-input",
                  'aria-label': name.replace(/_/g, ' '),
                  value: _nullishCoalesce(typed[name], () => ( '')),
                  onChange: e => onType(name, e.target.value),
                  onKeyDown: onFieldKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 109}}
                )
              )
            ))
            , _react2.default.createElement('p', { className: "tdlg-meta", __self: this, __source: {fileName: _jsxFileName, lineNumber: 118}}, "Anything left empty goes in as a chip to fill in the message. Send stays off until it's filled."                  )
          )
        )
        ,  gone && _react2.default.createElement('p', { className: "tdlg-note tdlg-note--warn" , role: "status", __self: this, __source: {fileName: _jsxFileName, lineNumber: 121}},  gone , " The list has been refreshed."     ) 
      )
      , _react2.default.createElement('div', { className: "templates-dialog--foot", __self: this, __source: {fileName: _jsxFileName, lineNumber: 123}}
        ,  !insertable && _react2.default.createElement('span', { className: "tdlg-meta", __self: this, __source: {fileName: _jsxFileName, lineNumber: 124}}, "Not available in this chat. You can still edit it."         ) 
        , _react2.default.createElement('span', { className: "templates-dialog--foot-gap", __self: this, __source: {fileName: _jsxFileName, lineNumber: 125}} )
        ,  insertable && (
          _react2.default.createElement(_controls.DialogButton, { busy: busy, disabled: needsPatient && !patientKey, onClick: onInsert, __self: this, __source: {fileName: _jsxFileName, lineNumber: 127}}, "Insert"
            ,  left > 0 && _react2.default.createElement(_react2.default.Fragment, null, " " , _react2.default.createElement('span', { className: "tdlg-btn--soft", __self: this, __source: {fileName: _jsxFileName, lineNumber: 128}}, "· " ,  left , " left" )) 
          )
        )
      )
    )
  )
}

exports. default = UsePane
